import { render, staticRenderFns } from "./ContactApp.vue?vue&type=template&id=00f95699"
import script from "./ContactApp.vue?vue&type=script&lang=js"
export * from "./ContactApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports